export const CHECKOUT_URL = 'https://workplace-safety-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/4npdaUZZgyWrXrHWWkWMFw/Diseno_sin_titulo_(73).png'

export const HERO_IMAGE_ALT =
  'Workplace Safety Atlas 6-in-1 box set: 6 professional visual training volumes for workplace safety instructors'

export const PRIMARY_CTA = 'GET WORKPLACE SAFETY ATLAS NOW!'

export const PRICE_LABEL = '$27 USD'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Workplace Hazard Identification & Risk Assessment Atlas' },
  { kind: 'included', label: 'Volume 02 — Warehouse, Logistics & Material Handling Safety Atlas' },
  { kind: 'included', label: 'Volume 03 — Machinery, Tools & Hazardous Energy Safety Atlas' },
  { kind: 'included', label: 'Volume 04 — Fire, Electrical & Emergency Safety Atlas' },
  { kind: 'included', label: 'Volume 05 — Falls, Ladders & Working at Height Safety Atlas' },
  { kind: 'included', label: 'Volume 06 — PPE, Chemical Hazards & Occupational Health Atlas' },
  { kind: 'bonus', label: 'Workplace Safety Instructor Lesson Planning Handbook' },
  { kind: 'bonus', label: 'Workplace Safety Assessment & Evaluation Toolkit' },
  { kind: 'bonus', label: 'Workplace Safety Scenario & Case Study Library' },
  { kind: 'bonus', label: 'Workplace Safety Instructor Question Bank' },
  { kind: 'bonus', label: 'Workplace Safety Emergency Training Session Vault' },
  { kind: 'extra', label: '100% Visual Main Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
